module.exports = __webpack_public_path__ + "img/coupon_bg.1dd8ff65.png";